import React from 'react';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { SendApplicationForm } from './sendApplicationForm/SendApplicationForm';
import { ApiContainer } from '../api';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { PageFallback } from './PageFallback';

export const SendCreditApplicationPage = () => {
  return (
    <PageContainer>
      <CardContainer>
        <ApiContainer>
          {({ lenderProfilesWithOcaOptions, isDataLoading, isSendOcaLinkLoading, handleSendOcaLink }) => (
            <RenderWithFallback isLoading={isDataLoading} fallBack={<PageFallback />}>
              <SendApplicationForm
                lenderProfilesWithOcaOptions={lenderProfilesWithOcaOptions}
                isSendOcaLinkLoading={isSendOcaLinkLoading}
                handleSendOcaLink={handleSendOcaLink}
              />
            </RenderWithFallback>
          )}
        </ApiContainer>
      </CardContainer>
    </PageContainer>
  );
};
